import React from "react";

const StarRating = ({ score = 0 }) => {
    return (
        <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
                <svg
                    key={star}
                    viewBox="0 0 24 24"
                    className={`w-5 h-5 ${star <= score ? "text-yellow-400" : "text-gray-300"
                        }`}
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M12 17.27L18.18 21 16.54 13.97 22 9.24 14.81 8.63 12 2 9.19 8.63 2 9.24 7.46 13.97 5.82 21z" />
                </svg>
            ))}
        </div>
    );
};

export default StarRating;